import manage from '../router/routePermissions'

export default function checkRoute(id) {
  if (Object.values(manage)[0].includes(id)) return true
  return false
}
